<template lang="html">
  <div id="facturacion-page">

    <section class="container main-section">
      <b-form class="row justify-content-center" @submit="onSubmit">
        <div class="col-12">
          <div class="col-s-title">
            <h2 class="title">Facturación electrónica</h2>
          </div>
        </div>

        <div class="col-sm-10 col-md-8 col-lg-6 col-xl-5">
          <fieldset class="form-group">
            <label class="bv-no-focus-ring col-form-label pt-0" tabindex="-1" for="_pedido_n_">
              Número de pedido
              <span class="_btn-tooltip" v-b-tooltip.hover title="El numero de tu pedido lo encuentras en la parte superior derecha del documento">?</span>
            </label>

            <div>
              <b-form-input
                id="_pedido_n_"
                v-model="form.pedido"
                type="text"
                placeholder=""
                required
              ></b-form-input>
            </div>
          </fieldset>

          <!-- <b-form-group label="Número de pedido (?)">
            <b-form-input
              required
              v-model="form.pedido"
              type="text"
              placeholder=""
            ></b-form-input>
          </b-form-group> -->

          <b-form-group label="RFC">
            <b-form-input
              required
              v-model="form.rfc"
              type="text"
              placeholder=""
            ></b-form-input>
          </b-form-group>

          <b-form-group label="Correo electrónico">
            <b-form-input
              required
              v-model="form.correo"
              type="email"
              placeholder=""
            ></b-form-input>
          </b-form-group>

          <b-button type="submit" class="btn-send">Enviar</b-button>
        </div>
      </b-form>
    </section>

    <sweet-modal :icon="modal.icon" :blocking="modal.block" :hide-close-button="modal.block" ref="modal">
        <div class="fa-3x" v-if="modal.icon== ''"><i class="fas fa-spinner fa-pulse"></i></div><br/>
        {{modal.msg}}
        <div class="col-12 text-center" style="padding-top: 20px;" v-if="modal.icon == 'success'">
        <b-button class="btn btn-primary" slot="button" v-on:click.prevent="$refs.modal.close();">OK</b-button>
        </div>
    </sweet-modal>

  </div>
</template>

<script>
export default {
  data(){
    return{
      form: {
        pedido: null,
        rfc: null,
        correo: null,
      },

      modal:{
          msg:'',
          icon:'',
          block:false,
        },
    }
  },

  methods: {
    onSubmit(evt) {
      evt.preventDefault();

      axios.post(tools.url('/api/facturacion'), this.form).then((response)=>{
        if(response.data.status == 'success'){
            this.modal.icon = "success";
            this.modal.msg = response.data.msg;
            this.modal.block = false;
            this.$refs.modal.open();
        }else{
            this.modal.icon = "error";
            this.modal.msg = response.data.msg;
            this.modal.block = false;
            this.$refs.modal.open();
        }
    }).catch((error)=>{
        console.log(error);
        //this.handleErrors(error);
    });
    }
  }
}
</script>
